import DOMPurify from 'dompurify';

function clean(dirty: string) {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'br', 'ul', 'li', 'ol', 'h1', 'h2', 'h3', 'h4', 'span'],
    ALLOWED_ATTR: ['href', 'title', 'target', 'class'],
    FORCE_BODY: true,
  });
}

export const safeHtml = {
  mounted(el, binding) {
    el.innerHTML = clean(binding.value);
  },
  updated(el, binding) {
    el.innerHTML = clean(binding.value);
  }
};